function elementWidth(node, region, cfg) {
    if (cfg === void 0) { cfg = { ratio: 0.15 }; }
    return node.width < region.width * cfg.ratio;
}
export default {
    type: 'padding',
    usage: 'compare',
    expression: elementWidth,
};
//# sourceMappingURL=element-width.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/util/responsive/constraints/element-width.js
// module id = null
// module chunks = 